module.exports = __webpack_public_path__ + "img/zhuangxiangji2.1d00780c.jpg";